import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './kloudless.css';
import { connectKloudless, disconnectKloudless } from '../redux/actions/kloudlessActions';


class KloudlessSwitch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: null,
    };
  }
  componentDidMount = () => {
    // todo keep this in some config maybe?
    const params = {
      client_id: window.Drupal.settings.INTEGRATIONS_KLODULESS_APP_ID,
      scope: this.props.svcName,
    };

    const auth = window.Kloudless.authenticator(null, params, this.kloudlessCallback);
    this.setState({ auth });
  }

  onClick = () => {
    const { connectionId } = this.props;

    if (connectionId === null) {
      const { auth } = this.state;
      auth.launch();
    } else {
      this.props.dispatch(disconnectKloudless(connectionId));
    }
  }

  kloudlessCallback = (authResp) => {
    this.props.dispatch(connectKloudless(this.props.svcName, authResp));
  }

  render() {
    const { imgSrc, id, connectionId } = this.props;
    const iconCls = (connectionId)
      ? 'kloudless-switch on'
      : 'kloudless-switch';

    return (
      <div className="kloudless-control-holder" id={id} >
        <div className="kloudless-service-img">
          <img src={imgSrc} alt="logo" />
        </div>
        <div className="kloudless-service-switch">
          <div className={iconCls} onClick={this.onClick} />
        </div>
      </div>
    );
  }
}

KloudlessSwitch.propTypes = {
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  connectionId: PropTypes.string,  //eslint-disable-line
  svcName: PropTypes.string.isRequired,
  imgSrc: PropTypes.string.isRequired,
};

export default KloudlessSwitch;



/** WEBPACK FOOTER **
 ** ./src/kloudless/KloudlessSwitch.jsx
 **/